// ** React Imports
import { lazy } from 'react'

const MaterialApoyo = lazy(() => import('../../views/pages/material-apoyo'))
const Contactos     = lazy(() => import('../../views/pages/contactos'))
const Roles         = lazy(() => import('../../views/pages/roles'))
const Permisos      = lazy(() => import('../../views/pages/permisos'))
const Noticias      = lazy(() => import('../../views/pages/noticias'))
const Rutas         = lazy(() => import('../../views/pages/rutas'))
const TiposUsuario  = lazy(() => import('../../views/pages/tiposUsuario'))

const ContactosRoutes = [
  {
    element: <Contactos />,
    path: '/contactos/lista',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Noticias />,
    path: '/noticias',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Rutas />,
    path: '/administracion/rutas',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  // {
  //   element: <Roles />,
  //   path: '/administracion/roles',
  //   meta: {
  //     validPermission : true,
  //     appLayout: false,
  //     className: 'book-open'
  //   }
  // },
  {
    element: <Permisos />,
    path: '/administracion/permisos',
    meta: {
      appLayout: false,
      validPermission : false,
      className: 'book-open'
    }
  },
  {
    element: <TiposUsuario />,
    path: '/administracion/tipos-usuario',
    meta: {
      appLayout: false,
      validPermission : true,
      className: 'book-open'
    }
  }
]

export default ContactosRoutes
